module.exports = __webpack_public_path__ + "media/images/flags/1x1/shn-52be3d8e26320098edb96f54d2e02a4e.svg";